export default "__VITE_ASSET__Dju3I3ab__"